export default __webpack_public_path__ + "static/media/image-study-board-2-w.8e368ccf.webp";